import axiosInstance from "./axiosConfig";

export type QuestionnaireDoc = Record<string, unknown> & { id: string };

export type Prong1Source = {
  id: string;
  type?: string;
  description?: string;
  date?: string;
  exhibit?: string;
  link?: string;
};

export type AddProng1SourcePayload = Omit<Prong1Source, "id"> & {
  extra?: Record<string, unknown>;
};

export const QuestionnairesAPI = {
  async getQuestionnaire(individualId: string): Promise<QuestionnaireDoc> {
    const response = await axiosInstance.get<QuestionnaireDoc>(
      `/questionnaires/${individualId}`
    );
    return response.data;
  },

  /** Merge-writes answer keys (visa questionnaire answers, EB2 prong
   * buckets, usedDocuments, ...). */
  async patchQuestionnaire(
    individualId: string,
    updates: Record<string, unknown>
  ): Promise<QuestionnaireDoc> {
    const response = await axiosInstance.patch<QuestionnaireDoc>(
      `/questionnaires/${individualId}`,
      updates
    );
    return response.data;
  },

  async listProng1Sources(individualId: string): Promise<Prong1Source[]> {
    const response = await axiosInstance.get<Prong1Source[]>(
      `/questionnaires/${individualId}/prong-1-sources`
    );
    return response.data;
  },

  async addProng1Source(
    individualId: string,
    payload: AddProng1SourcePayload
  ): Promise<Prong1Source> {
    const response = await axiosInstance.post<Prong1Source>(
      `/questionnaires/${individualId}/prong-1-sources`,
      payload
    );
    return response.data;
  },

  /** Deletes the source; the backend renumbers remaining exhibits. */
  async deleteProng1Source(
    individualId: string,
    sourceId: string
  ): Promise<void> {
    await axiosInstance.delete(
      `/questionnaires/${individualId}/prong-1-sources/${sourceId}`
    );
  }
};
